import { formatDateToString, masker, mapToNumeric } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { mapFiles } from '@convenia/common-organisms/SystemFields/content/mappers/upload'
import { DEPENDENTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'

const mapName = (fullName) => {
  const [ name, ...last ] = fullName?.trim().split(' ') || [ '' ]

  return {
    name: name || '',
    lastName: last.join(' ') || ''
  }
}

export const mapDependent = (dependent = {}, params) => {
  const name = dependent.name || ''
  const lastName = dependent.lastName || ''

  return {
    id: dependent.id,
    name,
    lastName,
    fullName: `${name} ${lastName}`.trim(),
    foreigner: dependent.foreigner,
    familySalary: dependent.familySalary,
    ir: dependent.ir,
    cpf: masker('###.###.###-##', dependent.cpf),
    phone: masker('(##) #####-####', dependent.phone),
    email: dependent.email,
    description: dependent.description,
    motherName: dependent.motherName,
    birthDate: dependent.birthDate,
    genderId: dependent.gender?.id,
    educationTypeId: dependent.educationType?.id,
    relationshipId: dependent.dependentRelation?.id,
    documentFiles: mapFiles(dependent.documentFiles, params),
    hasWorkDisability: dependent.hasDisability
  }
}

export const mapDependentInput = ({ entityId, schema, data, invalidFields = [] } = {}) => {
  const {
    fullName,
    email,
    foreigner,
    familySalary,
    ir,
    cpf,
    phone,
    description,
    motherName,
    birthDate,
    genderId,
    educationTypeId,
    relationshipId,
    hasWorkDisability,
  } = data || {}

  const parsedName = mapName(fullName)

  const body = {
    foreigner,
    family_salary: familySalary,
    ir,
    description,
    custom_fields: mapCustomFieldValues({
      data,
      schema,
      entityId,
      sectionId: DEPENDENTS_AREA.DEPENDENTS,
    })
  }

  if (!invalidFields.includes('fullName')) {
    body.name = parsedName.name
    body.last_name = parsedName.lastName
  }

  if (!invalidFields.includes('relationshipId'))
    body.dependent_relation_id = relationshipId

  if (!invalidFields.includes('email'))
    body.email = email

  if (!invalidFields.includes('motherName'))
    body.mother_name = motherName

  if (!invalidFields.includes('genderId'))
    body.gender_id = genderId

  if (!invalidFields.includes('educationTypeId'))
    body.education_type_id = educationTypeId

  if (!invalidFields.includes('hasWorkDisability'))
    body.has_disability = hasWorkDisability

  if (!invalidFields.includes('cpf'))
    body.cpf = mapToNumeric(cpf) || null

  if (!invalidFields.includes('birthDate'))
    body.birth_date = birthDate ? formatDateToString(birthDate, 'YYYY-MM-DD') : null

  if (!invalidFields.includes('phone'))
    body.phone = mapToNumeric(phone) || null

  return body
}
